module.exports = __webpack_public_path__ + "img/wave.f1fd167d.png";